import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h3","key":"svg-2"}],["path",{"d":"M16 19h6","key":"svg-3"}]]

const IconFilter2Minus = createReactComponent('outline', 'filter-2-minus', 'Filter2Minus', __iconNode);

export default IconFilter2Minus;